function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function getSharedProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$tagName = _ref.tagName,
      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
      observerOptions = _ref.observerOptions,
      _ref$preLoad = _ref.preLoad,
      preLoad = _ref$preLoad === void 0 ? 1.5 : _ref$preLoad,
      _ref$listenedEvents = _ref.listenedEvents,
      listenedEvents = _ref$listenedEvents === void 0 ? function () {
    return ['scroll', 'resize', 'orientationChange'];
  } : _ref$listenedEvents,
      _ref$throttledWait = _ref.throttledWait,
      throttledWait = _ref$throttledWait === void 0 ? 100 : _ref$throttledWait;

  return {
    tagName: {
      type: String,
      default: tagName
    },
    observerOptions: {
      type: Object,
      default: observerOptions
    },
    preLoad: {
      type: Number,
      default: preLoad
    },
    listenedEvents: {
      type: Array,
      default: listenedEvents
    },
    throttledWait: {
      type: Number,
      default: throttledWait
    }
  };
}

var sharedComputed = {
  defaultObserverOptions: function defaultObserverOptions() {
    if (this.observerOptions !== undefined) {
      return this.observerOptions;
    }

    var percent = (this.preLoad - 1) * 100; // 1.5 -> 50

    return {
      rootMargin: "0px ".concat(percent, "% ").concat(percent, "% 0px")
    };
  }
};

var isInBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
var doesWindowHaveIo = isInBrowser && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
var script = {
  name: 'LazyRenderer',
  props: _objectSpread2({}, getSharedProps()),
  data: function data() {
    return {
      shouldLoadSlot: false,
      io: undefined,
      startTime: Date.now(),
      timeoutId: undefined
    };
  },
  computed: _objectSpread2({}, sharedComputed),
  mounted: function mounted() {
    var _this = this;

    if (!isInBrowser) {
      return;
    }

    if (doesWindowHaveIo) {
      this.initIo();
    } else {
      this.observeViewportToLoad();
      this.listenedEvents.forEach(function (event) {
        window.addEventListener(event, _this.observeViewportToLoadWithThrottle);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanup();
  },
  methods: {
    initIo: function initIo() {
      this.io = new IntersectionObserver(this.handleIntersect, this.defaultObserverOptions);
      this.io.observe(this.$el);
    },
    handleIntersect: function handleIntersect(entries) {
      var _this2 = this;

      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          _this2.load();
        }
      });
    },
    observeViewportToLoadWithThrottle: function observeViewportToLoadWithThrottle() {
      clearTimeout(this.timeoutId);
      var currentTime = Date.now();

      if (currentTime - this.startTime > this.throttledWait) {
        this.observeViewportToLoad();
        this.startTime = currentTime;
      } else {
        this.timeoutId = setTimeout(this.observeViewportToLoad, this.throttledWait);
      }
    },
    observeViewportToLoad: function observeViewportToLoad() {
      var _this$$el$getBounding = this.$el.getBoundingClientRect(),
          top = _this$$el$getBounding.top,
          bottom = _this$$el$getBounding.bottom,
          left = _this$$el$getBounding.left,
          right = _this$$el$getBounding.right;

      if (top <= window.innerHeight * this.preLoad && bottom > 0 && left <= window.innerWidth * this.preLoad && right > 0) {
        this.load();
      }
    },
    load: function load() {
      this.shouldLoadSlot = true;
      this.$emit('load');
      this.cleanup();
    },
    cleanup: function cleanup() {
      var _this3 = this;

      if (doesWindowHaveIo && this.io !== undefined) {
        this.io.disconnect();
        this.io = undefined;
      } else {
        this.listenedEvents.forEach(function (event) {
          window.removeEventListener(event, _this3.observeViewportToLoadWithThrottle);
        });
      }
    }
  }
};

if (doesWindowHaveIo) {
  /**
   * Minimal polyfill for Edge 15's lack of `isIntersecting`
   * See: https://github.com/w3c/IntersectionObserver/issues/211
   */
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
      get: function get() {
        return this.intersectionRatio > 0;
      }
    });
  }
}

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.tagName, {
    tag: "component"
  }, [_vm.shouldLoadSlot ? _vm._t("default") : _vm._e()], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var install = function installLazyRenderer(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (install.installed) return;
  install.installed = true;
  var tagName = options.tagName,
      _observerOptions = options.observerOptions,
      preLoad = options.preLoad,
      listenedEvents = options.listenedEvents,
      throttledWait = options.throttledWait;
  Vue.component(__vue_component__.name, Vue.extend(__vue_component__).extend({
    props: _objectSpread2({}, getSharedProps({
      tagName: tagName,
      observerOptions: function observerOptions() {
        return _observerOptions;
      },
      preLoad: preLoad,
      listenedEvents: listenedEvents,
      throttledWait: throttledWait
    })),
    computed: _objectSpread2({}, sharedComputed)
  }));
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
